export default __webpack_public_path__ + "static/media/fund-progress-icon.70b3766d.png";